import React from "react";
import { getLabel } from "../../../data/labels";
import SystemBetsNTuple from "./SystemBetsNTuple";

function SystemBetsNTupleGroup(props) {

    const descriptions = {
        1: getLabel('check_system_bets.single'),
        2: getLabel('check_system_bets.double'),
        3: getLabel('check_system_bets.triple')
    }

    return (
        <>   
                <legend>{descriptions[props.index] || props.index+"-"+getLabel('check_system_bets.nuple')}</legend>
                <table id={`systemTableItem_${props.index}`} className="tableCheckSystemBets" >
                    <thead>
                        <tr>
                            <th data-label="pr"></th>
                            <th data-label="events" >{getLabel('general.eventi')}</th>
                            <th data-label="bet">{getLabel('general.scommessa')}</th>
                            <th data-label="outcome">{getLabel('general.esito')}</th>
                            <th data-label="odd">{getLabel('mybets.quota')}</th>
                            <th data-label="total-odd">{getLabel('carrello.total_odds')}</th>
                            <th data-label="amount">{getLabel('carrello.system_bets.amount')}</th>
                            {/* <th data-label="bonus">{getLabel('general.bonus"')}</th> */}
                            <th data-label="winning">{getLabel('carrello.last_tickets_widget.winnings"')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.NTupleGroup && props.NTupleGroup.map((NTuple,index)=>{
                            return <SystemBetsNTuple key={index} index={index} NTuple={NTuple} />


                        })
                        }
                    </tbody>
                </table>
        </>
    )
}

export default SystemBetsNTupleGroup;